import FqApi from '@/services/fq-api'
// import ProtoBufApi from '@/services/protobuf-api'

export default {
  async getGLRoutingList() {
    const url = '/glmapping/list'
    const result = await FqApi.get(url)
    return result.data
  },

  async getGlAccountList() {
    const result = await FqApi.get('/glmapping/glaccounts')
    return result.data
  },

  async saveGLRouting(model, deepdiff) {
    if (deepdiff) {
      model.deepDiff = JSON.stringify(deepdiff)
    }
    const result = await FqApi.post('/glmapping/saveGLRouting', model)
    return result.data
  }
}
